module.exports = __webpack_public_path__ + "static/media/mobile-app-login-header.1c741e47.png";